import { render, staticRenderFns } from "./checkoutCounter.vue?vue&type=template&id=0da0f9f3&scoped=true&"
import script from "./checkoutCounter.vue?vue&type=script&lang=js&"
export * from "./checkoutCounter.vue?vue&type=script&lang=js&"
import style0 from "./checkoutCounter.vue?vue&type=style&index=0&id=0da0f9f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0f9f3",
  null
  
)

export default component.exports